import { useMemo } from 'react';

import {
  splitMyString,
  formatDatefromTimeStamp,
  formatDateTime,
  changeRequestedDate,
  strToArray,
} from '../utils/utils';

const useProcessedShortlist = (shortlist) => {
  return useMemo(() => {
    return shortlist.map((option) => {
      const newOption = { ...option };

      newOption.heroImageUrl && (newOption.images = [option.heroImageUrl, ...option.images]);
      newOption.tourScheduledDate &&
        (newOption.scheduleDate = `${option.tourScheduledDate} ${option.tourScheduledSlot}`);

      if (newOption?.tourRequestedDate && !newOption.tourCompleted) {
        option.requestedDate =
          option.tourRequestedDate &&
          option.tourRequestedDate?.length > 0 &&
          option.tourRequestedDate[0].split('-').shift();
      }

      if (newOption?.tourRequestedDate && newOption?.tourRequestedDate?.length > 0) {
        const requestedDatesArray = [];

        if (typeof newOption?.tourRequestedDate === 'string') {
          newOption.tourRequestedDate = strToArray(option?.tourRequestedDate);
        }

        newOption?.tourRequestedDate?.filter((x) => {
          const reqDate = x.split(' - ');

          if (reqDate.some((item) => item.trim().toLowerCase() === 'morning')) {
            requestedDatesArray.push(reqDate[0] + ' 10:00 AM');
          } else {
            requestedDatesArray.push(reqDate[0] + ' 12:00 PM');
          }
          requestedDatesArray.sort();

          newOption.requestedDateTime = requestedDatesArray;
        });
      }
      if (newOption?.requestedDateTime && newOption?.requestedDateTime?.length > 0) {
        const sortedRequestedDates = [];

        newOption?.requestedDateTime.filter((x) => {
          const reqDate = splitMyString(x, 2);

          if (reqDate.includes('AM')) {
            sortedRequestedDates.push(changeRequestedDate(reqDate[0]) + ' - Morning');
          } else {
            sortedRequestedDates.push(changeRequestedDate(reqDate[0]) + ' - Afternoon');
          }
          newOption.sortedRequestedDates = sortedRequestedDates;
        });
      }

      if (newOption.requestedDateTime && newOption.tourCompleted == false) {
        newOption.requestedDate =
          newOption.requestedDateTime &&
          newOption.requestedDateTime?.length > 0 &&
          formatDateTime(option.requestedDateTime[0]);
      }

      if (newOption.tourScheduledDate) {
        const sdate = `${formatDatefromTimeStamp(newOption.tourScheduledDate, 'MMM DD, YYYY')} ${
          newOption.tourScheduledSlot
        }`;

        newOption.scheduleDate = sdate;
      }

      return newOption;
    });
  }, [shortlist]);
};

export default useProcessedShortlist;
